import React from 'react';
import {Typography, type TypographyProps} from '@mui/material';
import {type CellContext, type RowData} from '@tanstack/react-table';

export interface GenericCellProps<TData extends RowData>
	extends CellContext<TData, any> {
	//boolean | number | string | null> {
	TypographyProps?: Partial<TypographyProps>;
	ref?: React.ForwardedRef<HTMLDivElement>;
}

/**
 * Display a `generic` formatted cell\
 */
export const GenericCellPrimitive = <TData extends RowData>(
	{renderValue, TypographyProps}: GenericCellProps<TData>,
	ref: React.ForwardedRef<HTMLDivElement>,
) => {
	const value = renderValue();
	return (
		<Typography
			ref={ref}
			title={value?.toString()}
			variant="body2"
			noWrap
			{...TypographyProps}
		>
			{value}
		</Typography>
	);
};

export const GenericCell = React.memo(
	React.forwardRef(GenericCellPrimitive),
) as <TData extends RowData>(props: GenericCellProps<TData>) => JSX.Element;

export default GenericCell;
